// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"464":"942cccc3","612":"942cccc3","749":"94c5be63"}[chunkId] + ".chunk.css";
};